import { createReducer } from "@reduxjs/toolkit";
import {
    failedWithdrawAction,
    resetWithdrawErrorStateAction,
    resetWithdrawStateAction,
    submitWithdrawAction,
    successWithdrawAction,
    setWithdrawFee
} from "../actions/WithdrawAction";

const initialState = {
    withdrawLoading: false,
    error: '',
    bankCode: '',
    accountName: '',
    accountNumber: '',
    password: '',
    reason: '',
    amount: 0,
    methodPayment: 0,
    successOnWithdraw: false,
    errorOnWithdraw: false,
    transfer_fee: 0,
    transfer_type: '',
    message: '',
};

const withdrawReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(submitWithdrawAction, (state, action) => ({
            ...state,
            withdrawLoading: true,
            bankCode: action.payload.bankCode,
            accountName: action.payload.accountName,
            accountNumber: action.payload.accountNumber,
            password: action.payload.password,
            reason: action.payload.reason,
            amount: action.payload.amount,
            methodPayment: action.payload.methodPayment,
            error: ''
        }))
        .addCase(successWithdrawAction, (state) => ({
            ...state,
            withdrawLoading: false,
            successOnWithdraw: true,
            errorOnWithdraw: false,
            error: ''
        }))
        .addCase(failedWithdrawAction, (state, action) => ({
            ...state,
            withdrawLoading: false,
            successOnWithdraw: false,
            error: action.payload.error,
            errorOnWithdraw: !action.payload.error,
            message: action.payload.message
        }))
        .addCase(resetWithdrawStateAction, (state) => ({
            ...state,
            withdrawLoading: false,
            error: '',
            bankCode: '',
            accountName: '',
            accountNumber: '',
            password: '',
            reason: '',
            amount: 0,
            successOnWithdraw: false,
            errorOnWithdraw: false,
            methodPayment: 0
        }))
        .addCase(resetWithdrawErrorStateAction, (state) => ({
            ...state,
            error: '',
        }))
        .addCase(setWithdrawFee, (state, action) => ({
            ...state,
            transfer_fee: action.payload.transfer_fee,
            transfer_type: action.payload.transfer_type,
            error: ''
        }));
});

export default withdrawReducer;
